import { Component } from '@angular/core';
import { LoaderService } from '../loaderService/loader.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {

  isLoading$ = this.loaderService.isLoading$;

  constructor(private loaderService: LoaderService) {}

}
